module.exports = __webpack_public_path__ + "static/media/BATTERIES White@3x.88dcf173.png";